import { render } from "./IllustrationViewer.vue?vue&type=template&id=4dc57704&scoped=true"
import script from "./IllustrationViewer.vue?vue&type=script&lang=js"
export * from "./IllustrationViewer.vue?vue&type=script&lang=js"

import "./IllustrationViewer.vue?vue&type=style&index=0&id=4dc57704&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc57704"]])

export default __exports__